// openTaskScoring.js
// Wspolna punktacja zadan otwartych E8/matura — zasada "wynik-first".
//
// Filozofia: w zadaniu wieloetapowym poprawny wynik koncowy praktycznie zawsze
// oznacza, ze uczen zrozumial metode. Drobne literowki/bledy zapisu w krokach
// posrednich nie powinny odbierac punktow. Dlatego:
//   - poprawny wynik koncowy => pelne punkty (tolerujemy literowki w obliczeniach),
//   - bledny wynik           => punkty czastkowe za pokazane etapy, ale nigdy
//     komplet (min(etapy, maxScore - 1)).
//
// Uzycie w checkAnswer zadania:
//   return scoreStaged({
//     resultOk,                  // czy wynik koncowy sie zgadza (z tolerancja)
//     milestones: [stepA, stepB],// booleany etapow posrednich
//     maxScore,
//     parts,                     // (opcjonalnie) etykiety etapow do UI
//   });

export function scoreStaged({ resultOk, milestones = [], maxScore, parts }) {
  const steps = milestones.filter(Boolean).length;

  // Poprawny wynik => komplet. Bez wyniku => tylko za pokazane etapy (nigdy komplet).
  const score = resultOk ? maxScore : Math.min(steps, maxScore - 1);

  const out = { isCorrect: score === maxScore, score, maxScore };
  if (parts) out.parts = parts;
  return out;
}

export default scoreStaged;
